<template>
  <div class="mb-4">
    <h5 class="mb-2">
      {{
        "bank_request_sent"
          | setText('Нажмите "отправить", чтобы сделать запрос в банк')
      }}
    </h5>
    <button class="btn btn-info btn-icon" @click="sendRequest">
      {{ "send" | setText("Отправить") }}
    </button>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "@/plugins/functions";

export default {
  methods: {
    async sendRequest() {
      this.$loading(true);

      const action = "requests";
      const url = this.data.bank.api_endpoint_url + action;
      const token = this.data.bank.api_token;
      const auth_type = this.data.bank.api_auth_type;
      const method = "post";
      const data = this.data.form_data;
      try {
        const check = await this.$http.get(`loans/${this.data["id"]}`);
        if (check.data.data.exchange_id) {
          this.$emit("input", {
            state: "sent",
          });
          return false;
        }
      } catch (error) {}
      logger(this.$http, {
        name: "Запрос в банк",
        url: url,
        method: method,
        req: JSON.stringify(data),
      });

      return this.$http({
        method: method,
        data: toFormData(data),
        url: url,
        headers: {
          "Content-Type": `multipart/form-data`,
          Authorization: `${auth_type} ${token}`,
          "api-version": `1`,
          platform: `web`,
          language: `ru`,
          Accept: `application/json`,
        },
      })
        .then((response) => {
          const data = response.data;
          if (data && data.data && data.success === true) {
            this.$emit("input", {
              state: "sent",
              status: JSON.stringify(response.data),
              exchange_id: data.data.id,
            });
          } else if (!data.success) {
            alert("Неизвестная ошибка");
            this.$loading(false);
          }
          //отправка нового статуса

          return response.data;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },
  },
  data: () => ({}),
  props: ["value", "data"],
};
</script>
<style>
</style>
 